import { createAction } from 'shared/utils';

export const APPLICATION_INIT = createAction('APPLICATION_INIT');
export const APPLICATION_PERMISSION_GETS = createAction('APPLICATION_PERMISSION_GETS');
export const LOGIN = createAction('LOGIN');
export const LOGOUT = createAction('LOGOUT');
export const PROFILE_UPDATE = createAction('PROFILE_UPDATE');
